<template>
  <v-container id="generar-obligacion" fluid>
    <v-dialog v-model="show" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline">
          Generar obligaciones
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-select v-model="obligacionSelected" :items="obligacionTipo" label="Obligacion" :readonly="blockObligacion" return-object item-text="descripcion" />
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="cantidad" color="gold" :label="montoCantidad" :readonly="disabledCantidad" />
            </v-col>
            <v-col cols="12" class="pt-1 pb-1">
              <v-text-field v-model="descripcion" maxlength="250" color="gold" label="Descripción" class="pt-1" />
            </v-col>
            <v-spacer />
            <v-col v-if="!disabledCantidad" cols="12">
              <v-row>
                <v-col cols="12">
                  <h4>
                    Período
                  </h4>
                  <v-divider />
                </v-col>
                <v-col cols="6">
                  <v-menu ref="menuDesde" v-model="menuDesde" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                    <template v-slot:activator="{ on }">
                      <validation-provider v-slot="{ errors }" name="Inicio período" rules="required">
                        <v-text-field v-model="periodoDesde" prepend-inner-icon="mdi-calendar-outline" color="gold" :error-messages="errors" label="Inicio período" readonly v-on="on" />
                      </validation-provider>
                    </template>
                    <v-date-picker v-model="periodoDesde" color="gold" landscape scrollable no-title locale="es-419" :min="fechaDesde" @input="menuDesde = false" />
                  </v-menu>
                </v-col>
                <v-col cols="6">
                  <v-menu ref="menuHasta" v-model="menuHasta" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                    <template v-slot:activator="{ on }">
                      <validation-provider v-slot="{ errors }" name="Fin período" rules="required">
                        <v-text-field v-model="periodoHasta" prepend-inner-icon="mdi-calendar-outline" color="gold" :error-messages="errors" label="Fin período" readonly v-on="on" />
                      </validation-provider>
                    </template>
                    <v-date-picker v-model="periodoHasta" color="gold" landscape scrollable no-title locale="es-419" :max="fechaHasta" @input="menuHasta = false" />
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="auto">
              <v-item-group v-model="numeroDeCuotas">
                <v-subheader class="pa-0" style="height: 22px">
                  <span>Generar obligacion cada (meses)</span>
                </v-subheader>
                <v-item v-for="n in presetCuotas" :key="n" v-slot="{ active, toggle }" :value="n">
                  <v-chip active-class="purple--text" :input-value="active" @click="toggle">
                    {{ n }}
                  </v-chip>
                </v-item>
              </v-item-group>
            </v-col>
            <v-spacer />
            <v-col cols="auto" class="mr-4">
              <v-row align="center">
                <v-text-field v-model="numeroDeCuotas" type="number" step="1" min="1" :max="maxCuotasCant" color="gold" label="Personalizar" style="width: 80px" />
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click="cerrarDialog">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" text @click="enviarObligacion">
            Aceptar
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import dayjs from 'dayjs'

  export default {
    name: 'GenerarObligacion',
    props: {
      fechaDesde: {
        type: String,
        required: false,
        default: '',
      },
      fechaHasta: {
        type: String,
        required: false,
        default: '',
      },
      show: {
        type: Boolean,
        required: true,
        default: false,
      },
      obligacionExistente: {
        type: Object,
        required: false,
        default: null,
      },
    },
    data () {
      return {
        obligacionTipo: [],
        obligacionSelected: {},
        disabledCantidad: false,
        menuDesde: false,
        menuHasta: false,
        blockObligacion: false,
        cantidad: 0,
        descripcion: ((this.obligacionExistente) ? this.obligacionExistente.descripcion : ''),
        presetCuotas: [1, 3, 6, 12, 18, 24],
        numeroDeCuotas: 1,
        periodoDesde: this.fechaDesde,
        periodoHasta: this.fechaHasta,
        maxCuotasCant: '1',
      }
    },
    computed: {
      montoCantidad () {
        return (this.obligacionSelected.valor_monetario_sn) ? 'Monto' : 'Cantidad'
      },
    },
    watch: {
      fechaDesde (val) {
        this.periodoDesde = val
      },
      fechaHasta (val) {
        this.periodoHasta = val
      },
      periodoDesde () {
        this.generarPresetCuotas()
      },
      periodoHasta () {
        this.generarPresetCuotas()
      },
      show (val) {
        if (val) {
          this.generarPresetCuotas()
        }
      },
      obligacionSelected (val) {
        if (val.valor_monetario_sn) {
          this.disabledCantidad = false
        } else {
          this.cantidad = 1
          this.disabledCantidad = true
        }
      },
      obligacionExistente (val) {
        if (val) {
          this.descripcion = val.descripcion
          this.obligacionSelected = val.obligacion
          this.blockObligacion = true
        }
      },
    },
    created () {
      this.getTipoObligacion()
    },
    methods: {
      enviarObligacion () {
        let nObligacion = {}
        if (this.obligacionExistente !== null) {
          nObligacion = this.obligacionExistente
        }

        nObligacion.descripcion = this.descripcion
        nObligacion.obligacion_id = this.obligacionSelected.id
        nObligacion.obligacion = this.obligacionSelected

        if (this.obligacionExistente) {
          nObligacion.detalle_obligacion_representante = this.obligacionExistente.detalle_obligacion_representante.concat(this.generarObligacion())
        } else {
          nObligacion.detalle_obligacion_representante = this.generarObligacion()
        }
        this.reset()
        this.cerrarDialog()
        this.$emit('nuevaObligacion', nObligacion)
      },
      generarObligacion () {
        const cantObligaciones = Math.floor(this.maxCuotasCant / this.numeroDeCuotas)
        const detalleObligaciones = []
        const firstMonth = dayjs(this.periodoDesde)
        let nextMonth = firstMonth.add(this.numeroDeCuotas, 'month')
        for (let index = 1; index <= cantObligaciones; index++) {
          const obligacion = {
            cantidad: parseInt(this.cantidad, 10),
            vencimiento: dayjs(nextMonth).format('YYYY-MM-DD'),
          }
          nextMonth = nextMonth.add(this.numeroDeCuotas, 'month')
          detalleObligaciones.push(obligacion)
        }
        return detalleObligaciones
      },
      getTipoObligacion () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/obligacion' }).then(response => { this.obligacionTipo = response })
      },
      generarPresetCuotas () {
        const desde = dayjs(this.periodoDesde)
        const hasta = dayjs(this.periodoHasta)
        const cantMesesPosibles = hasta.diff(desde, 'month')
        this.maxCuotasCant = cantMesesPosibles.toString()
        const cuotas = [1, 3, 6, 12, 18, 24]
        if (cuotas.indexOf(cantMesesPosibles) === -1) {
          cuotas.push(cantMesesPosibles)
        }
        this.presetCuotas = []
        for (let i = 0; i <= cuotas.length; i++) {
          if (cuotas[i] <= cantMesesPosibles) {
            this.presetCuotas.push(cuotas[i])
          }
        }
      },
      cerrarDialog () {
        this.reset()
        this.$emit('close')
      },
      reset () {
        this.descripcion = ''
        this.cantidad = 0
        this.obligacionSelected = {}
        this.numeroDeCuotas = 1
        this.periodoDesde = this.fechaDesde
        this.periodoHasta = this.fechaHasta
        this.blockObligacion = false
      },
    },
  }
</script>
